import Vue from 'vue'
import { createModel } from './utils/create_model'
import { currentMall } from './mall'
import { dcb } from '@dcb/jssdk'
import { devOrProd } from './utils/dev_or_prod'
import { inWechatWebView } from 'vtils'
import { isChinaChannel } from './channel'
import { logg } from './utils/logg'
import { PageName } from './router'

const ua = navigator.userAgent.toLowerCase()
const inDcb = dcb.getEnvSync().dcb
const inAlipay = dcb.getEnvSync().alipay
const inWechat = inWechatWebView()
const inRedChina = ua.includes('redchina')
const inYancheng = ua.includes('ycsmt')
const inLove = ua.includes('love-calculator')
const inGuangDa = ua.includes('yunjiaofeiclient')
// https://developers.weixin.qq.com/community/develop/doc/00022e37c78b802f186750b5751000
const inWeapp =
  inWechat &&
  (ua.includes('miniprogram') ||
    // @ts-ignore
    window.__wxjs_environment === 'miniprogram')
const openIdCacheKey = `__duoduo_mall_openid_${inWeapp ? 'mp' : 'h5'}__`
const deviceIdCacheKey = `__duoduo_mall_tv_deviceid__`
const tvHotelIdCacheKey = `__duoduo_mall_tv_hotelid__`
const tvHotelRoomNoCacheKey = `__duoduo_mall_tv_hotelroomno__`

const inThirdApp = location.href.includes('isThirdApp=true')

export const globalModel = createModel({
  // 是否白名单页面
  isWhitePage: location.href.includes('bridge/wxpay_callback'),

  // 是否在多彩宝内
  inDcb: inDcb,

  // 是否在支付宝
  inAlipay: inAlipay,

  // 是否在中国红app内
  inRedChina: inRedChina,

  // 是否在盐城 APP 内
  inYancheng: inYancheng,

  // 是否在光大银行 APP 内
  inGuangDa: inGuangDa,

  // 支付类型
  payType: inAlipay
    ? 1
    : inWechat
    ? 4
    : inRedChina || inYancheng || inThirdApp || inGuangDa
    ? 6
    : undefined,

  // 是否在小程序中
  inWeapp: inWeapp,

  // 是否在爱情计算器
  inLove: inLove,

  // 是否纯净版
  isPure:
    location.href.includes('isPure=true') ||
    // 电科院商城
    location.href.includes('/dky/'),

  // 本地时间与服务器时间的差值
  serverTimeDiff: 0,

  // 环境信息
  env: {} as ReturnType<typeof dcb.getEnvSync>,

  // 是否是调试模式
  isDebug: devOrProd(
    true && !location.href.includes('isDebug=false'),
    location.href.includes('isDebug=true'),
  ),

  // 来自消费券领取
  fromCoupon: location.href.includes('fromCoupon'),

  // 上个页面的名称
  lastPageName: '',

  // 登录弹窗是否可见
  loginDialogVisible: false,

  // 登录成功回调
  loginDialogSuccessCallbacks: [],

  // 登录取消回调
  loginDialogCancelCallbacks: [],

  // 离开弹窗是否可见
  leaveDialogVisible: false,

  // 离开弹窗提示信息
  leaveDialogMessage: '前往国美真快乐小程序',

  // 离开弹窗跳转地址
  leaveDialogUrl: 'https://baidu.com',

  // 是否在微信浏览器中
  inWechatWebView: inWechat,

  // 电视-酒店订单酒店Id
  tvHotelId:
    new URLSearchParams(location.hash.split('?')[1] || location.search).get(
      'tvHotelId',
    ) ||
    sessionStorage.getItem(tvHotelIdCacheKey) ||
    '',
  // 电视-酒店订单酒店房间号
  tvHotelRoomNo:
    new URLSearchParams(location.hash.split('?')[1] || location.search).get(
      'tvHotelRoomNo',
    ) ||
    sessionStorage.getItem(tvHotelRoomNoCacheKey) ||
    '',
  // 当前电视机设备id
  currentDeviceId:
    new URLSearchParams(location.hash.split('?')[1] || location.search).get(
      'deviceId',
    ) ||
    sessionStorage.getItem(deviceIdCacheKey) ||
    '',

  // 用户 openid
  openid:
    new URLSearchParams(location.hash.split('?')[1] || location.search).get(
      'openId',
    ) ||
    localStorage.getItem(openIdCacheKey) ||
    '',

  // 是否消费券商城
  isCouponMall:
    location.href.includes('dcb-mall-china') ||
    location.href.includes('isCouponMall=true'),

  // 是否全国版商城
  isChinaMall: currentMall.mall_app_name === 'china-mall' || isChinaChannel,

  // 是否内嵌
  isEmbed: location.href.includes('isEmbed=true'),

  // 是否使用 Sentry
  isSentry: location.href.includes('isSentry=true'),

  // 首页 TAB 是否能返回顶部
  homeTabCanBackTop: false,

  // 分享指引是否可见
  shareGuideVisible: false,

  //是否秒杀下单
  isSeckill: false,

  // 分享指引类名
  shareGuideText: '',

  // 动态渲染的节点列表
  dynamicRenderNodes: [],

  // 是否TV端
  isTV: process.env.VUE_APP_RUNTIME === 'tv' || location.href.includes('/tv/'),

  // 是否模拟TV端
  isTVSimulate:
    !!process.env.VUE_APP_SIMULATE ||
    location.href.includes('isTVSimulate=true'),

  // 业务首页地址
  bizHomeUrl: decodeURIComponent(
    location.href.match(/[?&](?:bizHomeUrl)=(.*?)([#&\b]|$)/)?.[1] || '',
  ),

  // 业务我的订单地址
  bizOrderUrl: decodeURIComponent(
    location.href.match(/[?&](?:bizOrderUrl)=(.*?)([#&\b]|$)/)?.[1] || '',
  ),

  // 来自用户
  fromUser: decodeURIComponent(
    location.href.match(/[?&](?:fromUser)=(.*?)([#&\b]|$)/)?.[1] || '',
  ),

  // 来自电视端
  fromTV: location.href.includes('fromTV=true'),

  // 无权访问
  isAccessDenied: false,

  // https://yapi.gogpay.cn/project/2492/interface/api/235126
  channelIsShowTab: true,
  channelJumpRoute: '',
  channelIsShowDcbResource: true,
  channelShowOrderClassify: [] as Array<{
    label: string
    value: string
    pageName: PageName
  }>,
})

globalModel.watch(
  _ => [_.tvHotelId, _.tvHotelRoomNo, _.currentDeviceId, _.openid],
  () => {
    if (globalModel.state.tvHotelId) {
      logg('tv酒店id', globalModel.state.tvHotelId)
      sessionStorage.setItem(tvHotelIdCacheKey, globalModel.state.tvHotelId)
    }
    if (globalModel.state.tvHotelRoomNo) {
      logg('tv酒店房间号', globalModel.state.tvHotelRoomNo)
      sessionStorage.setItem(
        tvHotelRoomNoCacheKey,
        globalModel.state.tvHotelRoomNo,
      )
    }
    if (globalModel.state.currentDeviceId) {
      logg('tv设备id', globalModel.state.currentDeviceId)
      sessionStorage.setItem(
        deviceIdCacheKey,
        globalModel.state.currentDeviceId,
      )
    }
    if (globalModel.state.openid) {
      logg('微信用户OPENID', globalModel.state.openid)
      localStorage.setItem(openIdCacheKey, globalModel.state.openid)
    }
  },
  {
    immediate: true,
  },
)

window.globalModel = globalModel

Vue.prototype.$globalModel = globalModel

declare global {
  interface Window {
    globalModel: typeof globalModel
  }
}
